// Generate a react native component
import React from "react";
import { View, StyleSheet } from "react-native";
import TposModeIcon from "./TposModeIcon";
import { FilterButtons } from "./FilterButtons";
import { ALL_FILTER, SETTINGS } from "@/app/constants/menuItem";
import { useDispatch, useSelector } from "react-redux";
import { getFilters, getSelectedFilter } from "@/app/selectors/config";
import { getCurrentLocale, useTranslateText } from "@/app/utils";
import { doChangeFilter } from "@/app/actions/config";
import { Filter } from "@/app/types/config";
import { Locale } from "@/app/types";

const getFilterName = ({ name }: Filter, locale?: Locale): string =>
  name[locale || getCurrentLocale()];

const Filters: React.FC = () => {
  const { t, locale } = useTranslateText();
  const dispatch = useDispatch();
  const selectedFilter = useSelector(getSelectedFilter);
  const filters = useSelector(getFilters);

  return (
    <View testID="filtersContainer" style={styles.container}>
      <FilterButtons
        filters={[
          {
            category: ALL_FILTER,
            name: {
              ar: t("homeScreen.all", { locale: "ar" }),
              en: t("homeScreen.all", { locale: "en" }),
            },
          },
          ...filters,
          {
            category: SETTINGS,
            name: {
              ar: t("tpos.settings", { locale: "ar" }),
              en: t("tpos.settings", { locale: "en" }),
            },
          },
        ]}
        getName={(prop) => getFilterName(prop, locale)}
        onPress={(category) => {
          if (category !== selectedFilter) {
            dispatch(doChangeFilter(category));
          }
        }}
        selectedCategory={selectedFilter}
      />
      <TposModeIcon />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default Filters;
